import * as React from 'react'
import TextField from '@mui/material/TextField'
import Autocomplete from '@mui/material/Autocomplete'
import CircularProgress from '@mui/material/CircularProgress'
import { useGetRoadAutocompleteQuery } from './dtpService'
import { ListItemText } from '@mui/material'

interface AutocompleterProps {
  value?: string
  onChange?: (value: string) => void
  disabled?: boolean
}

export default function Asynchronous({
  value = '',
  onChange,
  disabled,
}: AutocompleterProps) {
  const [open, setOpen] = React.useState(false)
  const [inputValue, setInputValue] = React.useState(value)

  React.useEffect(() => {
    setInputValue(value)
  }, [value])

  const { data, isLoading } = useGetRoadAutocompleteQuery(inputValue, {
    skip: inputValue.length < 3 || disabled,
  })

  const options = React.useMemo<string[]>(() => {
    if (!data || !data.data) return []
    return Array.isArray(data.data) ? data.data : []
  }, [data])

  const handleOpen = () => {
    if (inputValue.length >= 3) {
      setOpen(true)
    }
  }

  const handleClose = () => {
    setOpen(false)
  }

  const handleInputChange = (
    event: React.SyntheticEvent,
    newInputValue: string
  ) => {
    setInputValue(newInputValue)
    onChange?.(newInputValue)
    if (newInputValue.length >= 3) {
      setOpen(true)
    } else {
      setOpen(false)
    }
  }

  const handleChange = (
    event: React.SyntheticEvent,
    newValue: string | null
  ) => {
    const valueToSet = newValue || ''
    setInputValue(valueToSet)
    onChange?.(valueToSet)
  }

  return (
    <Autocomplete
      open={open}
      style={{ width: '100%' }}
      onOpen={handleOpen}
      onClose={handleClose}
      value={value}
      inputValue={inputValue}
      onInputChange={handleInputChange}
      onChange={handleChange}
      isOptionEqualToValue={(option, value) => option === value}
      getOptionLabel={(option) => option}
      options={options}
      loading={isLoading}
      popupIcon={null}
      disabled={disabled}
      renderOption={(props, option) => {
        // eslint-disable-next-line react/prop-types
        const { key, ...otherProps } =
          props as React.HTMLAttributes<HTMLLIElement> & {
            key?: React.Key
          }
        return (
          <li
            key={key}
            {...otherProps}
          >
            <ListItemText primary={option} />
          </li>
        )
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label='Дорога'
          variant='filled'
          color='primary'
          size={'small'}
          className='input-organization'
          disabled={disabled}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <React.Fragment>
                {isLoading ? (
                  <CircularProgress
                    color='inherit'
                    size={10}
                    sx={{ top: '-5px', position: 'relative' }}
                  />
                ) : null}
                {params.InputProps.endAdornment}
              </React.Fragment>
            ),
          }}
        />
      )}
    />
  )
}
